import React, { useState, useEffect } from 'react'
import { useHistory, withRouter } from "react-router-dom";
import {
    Modal,
    Select,
    Form,
    Row,
    Col,
    Typography,
    message,
    Button,
} from "antd";
import { platformApi } from "../../../../api";
import './index.less'

const { Text, Title } = Typography;
const { Option } = Select;
const MechanicAssign = ({
    form,
    open,
    close,
    data,
    mechanic,
    setMechanic,
    editData,
    editable,
    modify,
}) => {
    const history = useHistory();
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const [error, setError] = useState({});
    const [mcid, setMcid] = useState('');
    const [loading, setLoading] = useState(false);
    // Mechanics available for this JC (excludes those with timer running elsewhere)
    const [availableMechanics, setAvailableMechanics] = useState([]);

    const mechanicLabel = (obj) => {
        if (!obj) return "";
        const profile = obj.profile || {};
        return (
            profile.employeeName ||
            profile.employeeId ||
            ""
        );
    };

    // Always keep current assignee as an Option so Select never shows raw cuid
    const withCurrentMechanic = (list) => {
        const current = data && data.mechanic;
        if (!current || !current.id) return list;
        if (list.some((m) => m.id === current.id)) return list;
        return [
            {
                id: current.id,
                profile: current.profile || null,
            },
            ...list,
        ];
    };

    //Edit Data
    useEffect(() => {
        if (data) {
            if (data.mechanic) {
                setFieldsValue({
                    mechanic: data.mechanic && data.mechanic.id,
                })
                setMcid(data.mechanic && data.mechanic.id)
            }
        }

    }, [data]);

    // Hide mechanics whose timer is running on a different Job Card.
    // Seed options immediately (incl. current mechanic) so the Select never flashes the record id.
    useEffect(() => {
        if (!open) {
            setAvailableMechanics([]);
            return;
        }
        const all = Array.isArray(mechanic) ? mechanic : [];
        const currentId = data && data.mechanic && data.mechanic.id;
        setAvailableMechanics(withCurrentMechanic(all));

        const excludeJobId = data && data.id ? data.id : undefined;
        platformApi
            .get("/api/jobOrder/busyMechanics", {
                params: excludeJobId ? { excludeJobId } : {},
            })
            .then((res) => {
                const payload = res.data;
                const busyIds =
                    (payload &&
                        payload.response &&
                        payload.response.data &&
                        payload.response.data.mechanicIds) ||
                    [];
                const busySet = new Set(busyIds);
                const filtered = all.filter(
                    (m) => !busySet.has(m.id) || m.id === currentId
                );
                setAvailableMechanics(withCurrentMechanic(filtered));
            })
            .catch((err) => {
                console.error("Error loading busy mechanics: ", err);
                setAvailableMechanics(withCurrentMechanic(all));
            });
    }, [open, data, mechanic]);
 
    const handleMechanic = (event) => {
        setMcid(event)
        setFieldsValue({
            mechanic: event
        })
    }
    const handleSubmit = () => {
        form.validateFields(async (validationError) => {
            if (validationError === null) {
                if (data) {
                    setLoading(true);
                    platformApi
                        .put(`/api/jobOrder/setMech/${data.id}`, {
                            mechanic: getFieldValue("mechainc") ? getFieldValue("mechainc") : mcid
                        })
                        .then((res) => {
                            let { data } = res;
                            if (data.code === 200) {
                                let { response } = data;
                                if (response.code === 200) {
                                    message.success(
                                        response.message || "Mechanic allocated. Use Start Work to begin/resume timer.",
                                        2
                                    );
                                    close();
                                } else {
                                    message.error(response.message || "Unable to update Job Order", 2);
                                }
                            } else if (data.response && data.response.message) {
                                message.error(data.response.message, 2);
                            } else {
                                message.error("Unable to update Job Order", 2);
                            }
                            form.resetFields();
                        })
                        .catch((err) => {
                            message.error("Unable to update Job Order", 2);
                            console.error("Error on Job Order : ", err);
                        })
                        .finally(() => {
                            setLoading(false);
                        });
                }
            }
        });
    };
    const clearFieldsAndClose = () => {
        form.resetFields();
        close();
        history.push('/autoadmin/job_order');
    };
    return (
        <Modal
            title={<Title level={4}>Mechanic Assign</Title>}
            visible={open}
            onCancel={clearFieldsAndClose}
            okText={!editable ? "Modify" : "Save"}
            okButtonProps={{ disabled: (!editable && !modify) || loading }}
            onOk={() => (editable ? handleSubmit() : setEditable(true))}
        >
            <Form className="purchase-form">
                <Row>
                    <Col span={12}>
                        <Text strong>
                            JOB NO&nbsp;&nbsp;&nbsp;: {data && data.jobNo}
                        </Text>
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col span={24}>
                        <Form.Item
                            className="purchase-form-element"
                            colon={false}
                            required
                            validateStatus={error.MECHANIC && error.MECHANIC.type}
                            help={error.MECHANIC && error.MECHANIC.message}
                            label={<Text>Mechanic</Text>}
                        >
                            {getFieldDecorator("mechanic", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Mechanic",
                                    },
                                ],
                            })(
                                <Select
                                    dropdownStyle={{
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                    }}
                                    showSearch
                                    optionFilterProp="children"
                                    showAction={["click", "focus"]}
                                    disabled={!editable}
                                    onChange={(event) => {
                                        handleMechanic(event)
                                    }}
                                    placeholder="Mechanic"
                                >
                                    {availableMechanics.map((obj) => (
                                        <Select.Option key={obj.id} value={obj.id}>
                                            {mechanicLabel(obj)}
                                        </Select.Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

const WrappedMechanicAssign = Form.create("mechanic_assign")(
    MechanicAssign
);

export default WrappedMechanicAssign;